import { useColorScheme } from "react-native";

/** The device colour scheme (`null` when unknown). React Native Web follows `matchMedia` live (R8). */
export function useDeviceScheme(): "light" | "dark" | null {
  const scheme = useColorScheme();
  return scheme === "light" || scheme === "dark" ? scheme : null;
}
